import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {SAVED_REPORTS_STATE_NAME, SavedReportsState} from "./savedReports";
import {SavedReport} from '../../interfaces/saved-reports';
import {SavedReportComponentObject, SavedReportComponentObjects} from '../../classes/saved-report-component-object';
import {Serializer, Serializers} from '../../interfaces/serializer';
import * as lodash from "lodash";
import {UserComponentObject} from "../../classes/user-component-object";

export const selectSavedReportsState: MemoizedSelector<object, SavedReportsState> = createFeatureSelector<SavedReportsState>(SAVED_REPORTS_STATE_NAME);

export const selectSavedReports: MemoizedSelector<object, Serializers<SavedReport>> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState) => savedReportsState.serialized
);

export const selectSavedReportsForExport: MemoizedSelector<object, Serializers<SavedReport>> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState) => savedReportsState.serialized
    .filter(savedReport => !['dashboard', 'chart', 'affinity'].includes(savedReport.attributes.report_type))
);

export const selectSavedReportsData: MemoizedSelector<object, { savedReports: Serializers<SavedReport>, included: Serializers<any> }> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState) => ({ savedReports: savedReportsState.serialized, included: savedReportsState.included})
);

export const selectSavedReportsIncluded: MemoizedSelector<object, Serializers<any>> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState) => savedReportsState.included
);

export const selectSavedReportsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState): boolean => savedReportsState.loading
);

export const selectSavedReportsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState): boolean => savedReportsState.loaded
);

export const selectSavedReportsInitialized: MemoizedSelector<object, boolean> = createSelector(
  selectSavedReportsState,
  (savedReportsState: SavedReportsState) => savedReportsState.initialized
);

export const selectSavedReportByID: (ID: number | string) => MemoizedSelector<object, SavedReportComponentObject, (state: SavedReportsState) => SavedReportComponentObject> = (ID: number | string) => createSelector(
  selectSavedReportsState,
  (state: SavedReportsState): SavedReportComponentObject => state.componentObjects.find((report: SavedReportComponentObject): boolean => report.payload.id == ID)
);

export const selectSavedReportComponentObjects: MemoizedSelector<object, SavedReportComponentObjects> = createSelector(
  selectSavedReportsState,
  (reportsState: SavedReportsState) => reportsState.componentObjects
);
